import { isPublicFeatureFlagEnabled } from '../constants/featureFlags';

export function normalizeStaffRoles(raw) {
  if (!Array.isArray(raw)) {
    return [];
  }

  return raw
    .map((role) => (typeof role === 'string' ? role : role?.name))
    .filter(Boolean);
}

export function resolveStaffRoles(authState) {
  const fromRoot = authState?.roles;
  const fromUser = authState?.user?.roles;

  if (Array.isArray(fromRoot) && fromRoot.length > 0) {
    return normalizeStaffRoles(fromRoot);
  }

  if (Array.isArray(fromUser) && fromUser.length > 0) {
    return normalizeStaffRoles(fromUser);
  }

  return [];
}

export function isAdmin(roles = []) {
  return Array.isArray(roles) && roles.includes('admin');
}

export function isWaiter(roles = []) {
  return Array.isArray(roles) && roles.includes('waiter');
}

/** Canonical staff role is `shisha_master`; aliases exist in older payloads. */
export const SHISHA_MASTER_ROLES = [
  'shisha_master',
  'nargelist',
  'narghilist',
  'hookahist',
  'hookah',
  'narghist',
];

export function isShishaMaster(roles = []) {
  return Array.isArray(roles) && roles.some((role) => SHISHA_MASTER_ROLES.includes(role));
}

/** Admins inherit every waiter/staff capability. */
export function canPerformWaiterActions(roles = []) {
  return isAdmin(roles) || isWaiter(roles);
}

export function canManageReservations(roles = []) {
  return canPerformWaiterActions(roles);
}

export function canAccessFeatureFlag(roles = [], featureFlags = [], flagKey) {
  if (isAdmin(roles)) {
    return true;
  }

  if (!flagKey) {
    return true;
  }

  return isPublicFeatureFlagEnabled(featureFlags, flagKey);
}

export function canAccessStaffMenuItem(item, roles = [], featureFlags = []) {
  if (!item) return false;

  // Admin can access every admin menu item and staff tool.
  if (isAdmin(roles)) {
    return true;
  }

  if (item.featureFlag && !canAccessFeatureFlag(roles, featureFlags, item.featureFlag)) {
    return false;
  }

  if (item.adminOnly) {
    return false;
  }

  if (item.staff) {
    return canPerformWaiterActions(roles);
  }

  if (!item.roles || item.roles.length === 0) {
    return true;
  }

  return item.roles.some((role) => roles.includes(role));
}
